import React from 'react';
import { api } from '../services/api';
import { useApi } from '../hooks/useApi';
import Topbar from '../components/Topbar';
import StatCard from '../components/StatCard';
import AnomaliesFeed from '../components/AnomaliesFeed';
import CrowdingPanel from '../components/CrowdingPanel';
import { IconAlert, IconRadar, IconUsers } from '../components/icons';

export default function Anomalies() {
  const a = useApi(() => api.anomalies());
  const c = useApi(() => api.crowding());
  const anomalies = a.data?.anomalies || [];
  const high = anomalies.filter((x) => x.gravite === 'haute').length;

  return (
    <>
      <Topbar title="Détection d'anomalies" subtitle="Pics et ruptures de trafic en temps réel (Dataset 1)" live={a.live} />
      <div className="content">
        {a.loading ? <div className="loading-screen">Chargement…</div> : (
          <>
            <div className="kpi-row kpi-row--3">
              <StatCard label="Anomalies actives" value={String(anomalies.length)} icon={IconAlert} delay={0} />
              <StatCard label="Gravité haute" value={String(high)} icon={IconRadar} trend={{ dir: high ? 'down' : 'flat', text: 'à traiter' }} delay={70} />
              <StatCard label="Zones surveillées" value={String(c.data?.stops?.length || 0)} icon={IconUsers} delay={140} />
            </div>
            <div className="grid grid--halves">
              <AnomaliesFeed data={a.data} delay={120} />
              <CrowdingPanel data={c.data} delay={180} />
            </div>
          </>
        )}
      </div>
    </>
  );
}
